import { Col, Row, Switch } from "antd";
import classNames from "classnames";
import { get, range } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "shared/components/Button";
import Input from "shared/components/Input";
import Slider from "shared/components/Slider";
import { NAME_SPACES } from "shared/locales/constants";
import { DEFAULT_NEEDS_LEVELS } from "../../../constants";
import spaIcon from "../../../../../Comparison/Acoris/Assets/icons/spa.svg";

const Filters = ({
  fields,
  setFields,
  onFilter,
  needs,
  setNeeds,
  data,
  needsLevels = DEFAULT_NEEDS_LEVELS,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.PROJECT);
  const DETAIL = t("DETAIL", { returnObjects: true });
  const [budgetError, setBudgetError] = useState(false);
  const [medecinDouceEnabled, setMedecinDouceEnabled] = useState(
    get(needs, "alternativeMedicine", false),
  );
  const switches = data.filter(({ order }) => order === 100);

  const levels = range(1, needsLevels + 1);

  return (
    <div className="card-skeleton--container highlighted">
      <div className="card-skeleton--wrapper">
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <h3 className="title--md">
              {DETAIL.TEMPLATES.FILTERS.LEVEL_OF_GUARANTEES}
            </h3>
          </Col>
          <Col lg={24} xs={24}>
            <Row gutter={[8, 8]}>
              {data
                ?.filter(({ order }) => order !== 100)
                .map(({ icon, label, id, value }) => (
                  <Col key={id} lg={24} xs={24}>
                    <div className="levels-coverage--wrapper">
                      <div className="d-flex align--center">
                        <img className="img" src={icon} alt={label} />
                        <span className="label-coverage">{label}</span>
                      </div>
                      <div className="custom-slider--wrapper">
                        <Slider
                          type="dot"
                          items={levels}
                          name={"grp" + label}
                          value={
                            (get(needs, value, 1) > needsLevels
                              ? needsLevels
                              : get(needs, value, 1)) || 1
                          }
                          onChange={(item) =>
                            setNeeds((prev) => ({
                              ...prev,
                              [value]: item,
                            }))
                          }
                        />
                      </div>
                    </div>
                  </Col>
                ))}
              {switches?.map(({ icon, label, id, value }) => (
                <Col key={id} lg={24} xs={24}>
                  <div className="levels-coverage--wrapper switch">
                    <div className="d-flex align--center">
                      <img className="img" src={icon} alt={label} />
                      <span className="label-coverage">{label}</span>
                    </div>
                    <div className="custom-slider--wrapper">
                      <Switch
                        className="button__switch"
                        checkedChildren={DETAIL.YES}
                        unCheckedChildren={DETAIL.NO}
                        defaultChecked={get(needs, value, 1) === 2}
                        onChange={(item) =>
                          setNeeds((prev) => ({
                            ...prev,
                            [value]: item ? 2 : 1,
                          }))
                        }
                      />
                    </div>
                  </div>
                </Col>
              ))}
              <Col lg={24} xs={24}>
                <div className="levels-coverage--wrapper switch">
                  <div className="d-flex align--center">
                    <img className="img" src={spaIcon} alt="Médecine douce" />
                    <span className="label-coverage">
                      {DETAIL.TEMPLATES.FILTERS.MEDECIN_DOUCE?.TITLE ||
                        "Médecine douce"}
                    </span>
                  </div>
                  <div className="custom-slider--wrapper">
                    <Switch
                      className="button__switch"
                      checkedChildren={DETAIL.YES}
                      unCheckedChildren={DETAIL.NO}
                      checked={medecinDouceEnabled}
                      onChange={(checked) => {
                        setMedecinDouceEnabled(checked);
                        setNeeds((prev) => ({
                          ...prev,
                          alternativeMedicine: checked,
                        }));
                      }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <div className="row-divider" />
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <h3 className="title--md">
              {DETAIL.TEMPLATES.FILTERS.BUDGET.TITLE}
            </h3>
          </Col>
          <Col lg={24} xs={24}>
            <Row gutter={[24, 24]}>
              <Col lg={24} xs={24}>
                <div className="custom-slider--wrapper">
                  <Slider
                    type="line"
                    tooltip={{
                      open: true,
                      formatter: (value) => `${value} €`,
                    }}
                    range
                    min={0}
                    max={1000}
                    value={[
                      get(fields, "budget.min"),
                      get(fields, "budget.max"),
                    ]}
                    onChange={([min, max]) => {
                      setBudgetError(false);
                      setFields((fields) => ({
                        ...fields,
                        budget: {
                          min,
                          max,
                        },
                      }));
                    }}
                  />
                </div>
              </Col>
              <Col lg={24} xs={24}>
                <div className="custom-input__wrapper reverse">
                  <Row align="top" gutter={[7, 7]}>
                    <Col lg={11} xs={24}>
                      <Input
                        type="number"
                        suffix="€"
                        min={0}
                        max={get(fields, "budget.max")}
                        value={get(fields, "budget.min")}
                        label={DETAIL.TEMPLATES.FILTERS.BUDGET.MIN}
                        onChange={({ target: { value } }) => {
                          const numValue = Number(value);
                          const currentMax = get(fields, "budget.max", 1000);
                          if (numValue <= 1000) {
                            if (numValue <= currentMax) {
                              setBudgetError(false);
                              setFields((fields) => ({
                                ...fields,
                                budget: {
                                  ...fields.budget,
                                  min: numValue,
                                },
                              }));
                            } else {
                              setBudgetError(true);
                            }
                          }
                        }}
                        onBlur={({ target: { value } }) => {
                          const numValue = Number(value);
                          if (numValue > get(fields, "budget.max")) {
                            setBudgetError(true);
                          } else {
                            setBudgetError(false);
                          }
                        }}
                        touched
                        errors={budgetError}
                      />
                    </Col>
                    <Col lg={2} xs={24}>
                      <div className="divider-input" />
                    </Col>
                    <Col lg={11} xs={24}>
                      <Input
                        type="number"
                        suffix="€"
                        min={get(fields, "budget.min")}
                        max="1000"
                        value={get(fields, "budget.max")}
                        label={DETAIL.TEMPLATES.FILTERS.BUDGET.MAX}
                        onChange={({ target: { value } }) => {
                          const numValue = Number(value);
                          const currentMin = get(fields, "budget.min", 0);
                          if (numValue <= 1000) {
                            if (numValue >= currentMin) {
                              setBudgetError(false);
                              setFields((fields) => ({
                                ...fields,
                                budget: {
                                  ...fields.budget,
                                  max: numValue,
                                },
                              }));
                            } else {
                              setBudgetError(true);
                            }
                          }
                        }}
                        onBlur={({ target: { value } }) => {
                          const numValue = Number(value);
                          if (numValue < get(fields, "budget.min")) {
                            setBudgetError(true);
                          } else {
                            setBudgetError(false);
                          }
                        }}
                        touched
                        errors={budgetError}
                      />
                    </Col>
                    <span
                      className={classNames("input--errors", {
                        hidden: !budgetError,
                      })}
                    >
                      {DETAIL.TEMPLATES.FILTERS.BUDGET.ERROR}
                    </span>
                  </Row>
                </div>
              </Col>
            </Row>
          </Col>
          <Col lg={24} xs={24}>
            <Button
              onClick={() =>
                onFilter({
                  min: get(fields, "budget.min"),
                  max: get(fields, "budget.max"),
                  needs: {
                    ...needs,
                    alternativeMedicine: medecinDouceEnabled,
                  },
                })
              }
              type="secondary"
              block
              disabled={get(fields, "budget.min") > get(fields, "budget.max")}
            >
              {DETAIL.TEMPLATES.FILTERS.BUTTON.TEXT.REFRESH_PRODUCT_LIST}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Filters;
